export default __webpack_public_path__ + "static/media/maestro, green.d095bd27.png";